var _rect, _path, _path2, _g, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateFortiNet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.983,
    y: 7.599,
    width: 16.07,
    height: 26.542,
    rx: 3,
    fill: "#C9A87A",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9A87A",
    fillOpacity: 0.16,
    d: "M27.711 7.332h7.775v5.2h-7.775z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.233 9.947a.95.95 0 0 0-.677.285.979.979 0 0 0 0 1.373.95.95 0 0 0 .677.285h9.573a.95.95 0 0 0 .677-.285.979.979 0 0 0 0-1.373.95.95 0 0 0-.677-.285H8.233zm-.957 14.571c0-.258.1-.505.28-.687a.95.95 0 0 1 .677-.284h9.573a.95.95 0 0 1 .677.284.979.979 0 0 1 0 1.374.95.95 0 0 1-.677.285H8.233a.95.95 0 0 1-.677-.285.978.978 0 0 1-.28-.687zm.957 2.914a.95.95 0 0 0-.677.285.978.978 0 0 0 0 1.374.95.95 0 0 0 .677.284h9.573a.95.95 0 0 0 .677-.284.979.979 0 0 0 0-1.374.95.95 0 0 0-.677-.285H8.233zM3.446 8.976c0-1.288.505-2.524 1.402-3.435A4.752 4.752 0 0 1 8.233 4.12h9.573c1.27 0 2.487.511 3.384 1.422a4.894 4.894 0 0 1 1.402 3.435v21.37a4.894 4.894 0 0 1-1.401 3.435 4.752 4.752 0 0 1-3.385 1.423H8.233a4.752 4.752 0 0 1-3.385-1.423 4.894 4.894 0 0 1-1.402-3.434V8.976zm4.787-2.914c-.762 0-1.492.307-2.03.853a2.936 2.936 0 0 0-.842 2.06v21.371c0 .773.302 1.515.841 2.061.539.547 1.27.854 2.03.854h9.574c.761 0 1.492-.307 2.03-.854a2.936 2.936 0 0 0 .842-2.06V8.976c0-.773-.303-1.514-.841-2.06a2.851 2.851 0 0 0-2.031-.854H8.233z",
    fill: "url(#czdlzd6mxa)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2sh7r1wh5b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.167 5.845h-7.333a.917.917 0 0 0-.917.917v5.5a.917.917 0 0 0 .917.916h2.75v.917h-1.375v.917h4.583v-.917h-1.375v-.917h2.75a.917.917 0 0 0 .917-.916v-5.5a.917.917 0 0 0-.917-.917zm0 6.417h-7.333v-5.5h7.333v5.5z",
    fill: "url(#p9ok3si2uc)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9A87A",
    fillOpacity: 0.16,
    d: "M27.612 22.376h7.775v5.2h-7.775z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.167 20.917h-7.334a.917.917 0 0 0-.916.916v5.5a.917.917 0 0 0 .916.917h2.75v.917h-1.375v.916h4.584v-.916h-1.375v-.917h2.75a.917.917 0 0 0 .916-.917v-5.5a.917.917 0 0 0-.916-.916zm0 6.416h-7.334v-5.5h7.334v5.5z",
    fill: "url(#914yfry8fd)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.043 19.573a.802.802 0 0 0 .235-.567.798.798 0 0 0-1.292-.637l-1.476-.738 1.476-.747a.81.81 0 1 0-.312-.628l-1.49.756a.784.784 0 1 0 0 1.242l1.49.752a.802.802 0 0 0 1.37.567z",
    fill: "url(#z3zvfdzjie)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "czdlzd6mxa",
    x1: 17.653,
    y1: 51.856,
    x2: -3.619,
    y2: 46.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p9ok3si2uc",
    x1: 33.719,
    y1: 19.922,
    x2: 24.375,
    y2: 16.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "914yfry8fd",
    x1: 32.946,
    y1: 37.931,
    x2: 20.016,
    y2: 33.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z3zvfdzjie",
    x1: 32.946,
    y1: 37.931,
    x2: 20.016,
    y2: 33.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2sh7r1wh5b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(26 4.928)",
    d: "M0 0h11v11H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateFortiNet);
export default __webpack_public_path__ + "static/media/corporateFortiNet.d217aba64d710b29b588ea0555702258.svg";
export { ForwardRef as ReactComponent };